import { render, staticRenderFns } from "./OrganizationProfilePet.vue?vue&type=template&id=58288730&scoped=true&"
import script from "./OrganizationProfilePet.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfilePet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58288730",
  null
  
)

export default component.exports